import React, { useState } from "react";

import FirstPlaceTrophy from "shared/ui/svg-icons/Leaderboard/Mobile/FirstPlace";
import SecondPlaceTrophy from "shared/ui/svg-icons/Leaderboard/Mobile/SecondPlace";
import ThirdPlaceTrophy from "shared/ui/svg-icons/Leaderboard/Mobile/ThirdPlace";
import LeaderboardTable from "./LeaderboardTable";
import TrophyEllipse from "./TrophyEllipse";
import LeaderboardModal from "./LeaderboardModal";

const LeaderboardMobile = ({
  currencyCode,
  data,
  firstPlace,
  secondPlace,
  thirdPlace,
  trophyHeaders,
  tableRows,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="leaderboard mobile">
      <LeaderboardModal data={data} modalOpen={modalOpen} closeModal={closeModal} />
      <div className="sr-only" id="form-instruction">
        The following form controls will update the content in the table below.
      </div>
      <div className="leader-title">{data.title}</div>
      <div className="leader-subtitle">
        <span>About challenge</span>
        <i className="fa fa-solid fa-angle-right arrow-right" onClick={openModal} />
      </div>
      <div className="cards">
        <TrophyEllipse
          currencyCode={currencyCode}
          Trophy={SecondPlaceTrophy}
          placeData={secondPlace}
        />
        <TrophyEllipse
          currencyCode={currencyCode}
          Trophy={FirstPlaceTrophy}
          placeData={firstPlace}
        />
        <TrophyEllipse
          currencyCode={currencyCode}
          Trophy={ThirdPlaceTrophy}
          placeData={thirdPlace}
        />
      </div>
      <LeaderboardTable tableRows={tableRows} trophyHeaders={trophyHeaders} />
    </div>
  );
};

export default LeaderboardMobile;
